/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="86.81" height="73.21" viewBox="0 0 86.81 73.21" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M92.78,41.25c12.87,0,23.28,11.79,23.28,26.22,0,11.38-7.1,22.45-19,32.85a115.67,115.67,0,0,1-13.19,10c-.61.4-1.21.78-1.8,1.15l-1.15.71-1.1.67-.8.47-.51.29-.66.38-.69.38a1.26,1.26,0,0,1-1.18,0l-.87-.48-1-.54-.8-.48-.86-.51c-2.44-1.49-5-3.19-7.69-5.09A89.85,89.85,0,0,1,45.94,89.69a1.25,1.25,0,0,1,2-1.53,87.67,87.67,0,0,0,18.39,17c2.31,1.65,4.58,3.15,6.74,4.49l1.13.69,1.17.7.52.3.75.43.94-.53.51-.3c1.38-.81,2.88-1.74,4.48-2.78a113.4,113.4,0,0,0,12.91-9.74c11.36-10,18.1-20.48,18.1-31,0-13.11-9.36-23.72-20.78-23.72A19.56,19.56,0,0,0,77.59,51.3a1.24,1.24,0,0,1-1.94,0,19.54,19.54,0,0,0-15.18-7.55c-11.42,0-20.78,10.61-20.78,23.72A26.81,26.81,0,0,0,41.13,76a1.25,1.25,0,0,1-2.37.79,29.37,29.37,0,0,1-1.57-9.29c0-14.43,10.4-26.22,23.28-26.22a21.81,21.81,0,0,1,16,7.14l.19.21.2-.21a21.81,21.81,0,0,1,15.54-7.14Z" transform="translate(-29.25 -41.25)" fill="#0e497b"/><path d="M65.18,64.69a1.25,1.25,0,0,1,2.3-.13l0,.13L78,93.61l7.18-11.47a1.24,1.24,0,0,1,.92-.57h14a1.25,1.25,0,0,1,.13,2.49H86.94l-8.18,13A1.25,1.25,0,0,1,76.58,97l0-.13L66.36,68.81,61.22,83.23a1.28,1.28,0,0,1-1,.82H30.5a1.25,1.25,0,0,1-.13-2.5H59.16Z" transform="translate(-29.25 -41.25)" fill="#fcb61c"/>
</svg>

    );
  }
}

Icon.displayName = 'HeartWithPulseOximeterWaveIcon';

export default Icon;
